export default __webpack_public_path__ + "static/media/key_strength_and_development_areas.72dd0bc3.svg";